/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpNetworkType } from '../models/GcpNetworkType';

export class GcpCloudSqlTarget {
  /**
  * The zone to restore the Cloud SQL instance to.
  */
  'zone': string;
  /**
  * The name of the Cloud SQL instance to restore.
  */
  'name': string;
  'networkType': GcpNetworkType;
  /**
  * The VPC network name (required for private networking).
  */
  'networkName'?: string;
  /**
  * The subnet name for the compute node (required for private networking).
  */
  'subnetName'?: string;
  /**
  * Host project ID for shared VPC (only required for private networking).
  */
  'networkHostProject'?: string;
  /**
  * Labels to apply to the restored Cloud SQL instance as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'labels'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkType",
      "baseName": "networkType",
      "type": "GcpNetworkType",
      "format": ""
    },
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlTarget.attributeTypeMap;
  }

  public constructor() {
  }
}



